import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DxoFullstackedsplineareaComponent } from 'devextreme-angular/ui/nested';
import { Quantity } from 'pumpcalc-core';
import { ResultTableComponent } from '../result-table/result-table.component';

// export class ResultTableButtons {

// };

@Component({
  selector: 'app-result-table-buttons',
  templateUrl: './result-table-buttons.component.html',
  styleUrls: ['./result-table-buttons.component.css']
})
export class ResultTableButtonsComponent implements OnInit {

  @Input()  resultTable:ResultTableComponent;
  @Input()  canToggleJustOneQuantity:boolean=true;
  public quantity = Quantity;

  constructor() {

  }

  ngOnInit() {
  }

  somethingSelected(){
    return this.resultTable?this.resultTable.somethingSelected:false;
  }

  showingSelected(){
    return this.resultTable?this.resultTable.showingSelected:false;
  }

  isRangedResult(){
    return this.resultTable?this.resultTable.isRangedResult:false;
  }

  chartPinned(){
    return this.resultTable?this.resultTable.chartPinned:false;
  }

  showComplex(){
    return this.resultTable?this.resultTable.showComplex:false;
  }

  buttonToggles(key):boolean{
    return this.resultTable?this.resultTable.buttonToggles[key]:false;
  }

}


//toggle quantity buttons on/off  - off for ranged result - on for single
